// RouteLink.js
import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";
import { VTYPE } from "./Utilities/VoucherConstants";

const LoginPage = React.lazy(() => import("./Pages/Login/LoginPage"));
const DashboardLayout = React.lazy(() => import("./Layout/DashboardLayout"));
const PrivateRoute = React.lazy(() => import("./Utilities/PrivateRoute"));
const DashboardHome = React.lazy(
  () => import("./Pages/Dashboard/DashboardHome"),
);

const BranchOffice = React.lazy(
  () => import("./Pages/BranchOffice/BranchOffice"),
);
const AddBranchOffice = React.lazy(
  () => import("./Pages/BranchOffice/AddBranchOffice"),
);
const EditBranchOffice = React.lazy(
  () => import("./Pages/BranchOffice/EditBranchOffice"),
);

const BatchMaster = React.lazy(
  () => import("./Pages/BatchMaster/BatchMaster"),
);
const AddBatchMaster = React.lazy(
  () => import("./Pages/BatchMaster/AddBatchMaster"),
);
const EditBatchMaster = React.lazy(
  () => import("./Pages/BatchMaster/EditBatchMaster"),
);

const Supplier = React.lazy(
  () => import("./Pages/Supplier/Supplier"),
);
const AddSupplier = React.lazy(
  () => import("./Pages/Supplier/AddSupplier"),
);
const EditSupplier = React.lazy(
  () => import("./Pages/Supplier/EditSupplier"),
);

const AccountGroup = React.lazy(
  () => import("./Pages/AccountGroup/AccountGroup"),
);
const AddAccountGroup = React.lazy(
  () => import("./Pages/AccountGroup/AddAccountGroup"),
);
const EditAccountGroup = React.lazy(
  () => import("./Pages/AccountGroup/EditAccountGroup"),
);

const DiscountRule = React.lazy(
  () => import("./Pages/DiscountRule/DiscountRule"),
);
const AddDiscountRule = React.lazy(
  () => import("./Pages/DiscountRule/AddDiscountRule"),
);
const EditDiscountRule = React.lazy(
  () => import("./Pages/DiscountRule/EditDiscountRule"),
);

const PrescriptionWithoutOrder = React.lazy(
  () => import("./Pages/CustomerReports/PrescriptionWithoutOrder")
);
const OpeningStock = React.lazy(
  () => import("./Pages/OpeningStock/OpeningStock"),
);

const PurchaseList = React.lazy(
  () => import("./Pages/PurchaseEntry/PurchaseList"),
)

const PurchaseEntry = React.lazy(
  () => import("./Pages/PurchaseEntry/PurchaseEntry"),
);
const EditPurchaseEntry = React.lazy(
  () => import("./Pages/PurchaseEntry/EditPurchaseEntry"),
);

const PurchaseReturnList = React.lazy(
  () => import("./Pages/PurchaseEntry/PurchaseReturnList"),
);
const PurchaseReturnEntry = React.lazy(
  () => import("./Pages/PurchaseEntry/PurchaseReturnEntry"),
);
const EditPurchaseReturnEntry = React.lazy(
  () => import("./Pages/PurchaseEntry/EditPurchaseReturnEntry"),
);

const SaleList = React.lazy(
  () => import("./Pages/SaleEntry/SaleList"),
);
const SaleEntry = React.lazy(
  () => import("./Pages/SaleEntry/SaleEntry"),
),
  POSEntry = React.lazy(
  () => import("./Pages/SaleEntry/POSEntry"),
),
  POSList = React.lazy(
  () => import("./Pages/SaleEntry/POSList"),
),
EditPOSEntry = React.lazy(
  () => import("./Pages/SaleEntry/EditPOSEntry"),
);
const EditSaleEntry = React.lazy(
  () => import("./Pages/SaleEntry/EditSaleEntry"),
);

const OrderList = React.lazy(
  () => import("./Pages/OrderManagement/OrderList"),
);
const OrderDetail = React.lazy(
  () => import("./Pages/OrderManagement/OrderDetail"),
);
const ReturnRequestList = React.lazy(
  () => import("./Pages/OrderManagement/ReturnRequestList"),
);

const Banner = React.lazy(
  () => import("./Pages/Banner/Banner"),
);
const AddBanner = React.lazy(
  () => import("./Pages/Banner/AddBanner"),
);
const EditBanner = React.lazy(
  () => import("./Pages/Banner/EditBanner"),
);

const StockItemWise = React.lazy(
  () => import("./Pages/Inventory/StockItemWise"),
);
const StockBatchWise = React.lazy(
  () => import("./Pages/Inventory/StockBatchWise"),
);
const StockMrpWise = React.lazy(
  () => import("./Pages/Inventory/StockMrpWise"),
);

const DeliveryBoy = React.lazy(
  () => import("./Pages/DeliveryBoy/DeliveryBoy"),
);
const AddDeliveryBoy = React.lazy(
  () => import("./Pages/DeliveryBoy/AddDeliveryBoy"),
);
const EditDeliveryBoy = React.lazy(
  () => import("./Pages/DeliveryBoy/EditDeliveryBoy"),
);

const ComingSoon = React.lazy(
  () => import("./Utilities/ComingSoon"),
);

const Users = React.lazy(
  () => import("./Pages/UserManagement/User/Users"),
);
const AddUser = React.lazy(
  () => import("./Pages/UserManagement/User/AddUser"),
);
const EditUser = React.lazy(
  () => import("./Pages/UserManagement/User/EditUser"),
);

const SuspenseWrap = ({ children }) => (
  <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
);

const routes = [
  {
    path: "/login",
    element: (
      <SuspenseWrap>
        <LoginPage />
      </SuspenseWrap>
    ),
  },
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    element: (
      <SuspenseWrap>
        <PrivateRoute />
      </SuspenseWrap>
    ),
    children: [
      {
        path: "/dashboard",
        element: (
          <SuspenseWrap>
            <DashboardLayout />
          </SuspenseWrap>
        ),
        children: [
          {
            index: true,
            element: (
              <SuspenseWrap>
                <DashboardHome />
              </SuspenseWrap>
            ),
          },
          {
            path: "discountrule",
            element: (
              <SuspenseWrap>
                <DiscountRule />
              </SuspenseWrap>
            ),
          },
          {
            path: "discountruleadd",
            element: (
              <SuspenseWrap>
                <AddDiscountRule />
              </SuspenseWrap>
            ),
          },
          {
            path: "discountruleedit",
            element: (
              <SuspenseWrap>
                <EditDiscountRule />
              </SuspenseWrap>
            ),
          },
          {
            path: "accountgroup",
            element: (
              <SuspenseWrap>
                <AccountGroup />
              </SuspenseWrap>
            ),
          },
          {
            path: "accountgroupadd",
            element: (
              <SuspenseWrap>
                <AddAccountGroup />
              </SuspenseWrap>
            ),
          },
          {
            path: "accountgroupedit",
            element: (
              <SuspenseWrap>
                <EditAccountGroup />
              </SuspenseWrap>
            ),
          },
          {
            path: "supplier",
            element: (
              <SuspenseWrap>
                <Supplier />
              </SuspenseWrap>
            ),
          },
          {
            path: "supplieradd",
            element: (
              <SuspenseWrap>
                <AddSupplier />
              </SuspenseWrap>
            ),
          },
          {
            path: "supplieredit",
            element: (
              <SuspenseWrap>
                <EditSupplier />
              </SuspenseWrap>
            ),
          },
          {
            path: "batchmaster",
            element: (
              <SuspenseWrap>
                <BatchMaster />
              </SuspenseWrap>
            ),
          },
          {
            path: "batchmasteradd",
            element: (
              <SuspenseWrap>
                <AddBatchMaster />
              </SuspenseWrap>
            ),
          },
          {
            path: "batchmasteredit",
            element: (
              <SuspenseWrap>
                <EditBatchMaster />
              </SuspenseWrap>
            ),
          },
          {
            path: "branchoffice",
            element: (
              <SuspenseWrap>
                <BranchOffice />
              </SuspenseWrap>
            ),
          },
          {
            path: "branchofficadd",
            element: (
              <SuspenseWrap>
                <AddBranchOffice />
              </SuspenseWrap>
            ),
          },
          {
            path: "branchofficeedit",
            element: (
              <SuspenseWrap>
                <EditBranchOffice />
              </SuspenseWrap>
            ),
          },
          {
            // Opening Stock and Damage are ONE component parameterised by `vtype` — the
            // stock-entry API is identical for both and only that value differs.
            //
            // The `key` is load-bearing, exactly as it is for OrderList's pickup route:
            // without a distinct key React reuses the same instance across the two routes
            // and the previous voucher's rows stay on screen after navigating.
            path: "openingstock",
            element: (
              <SuspenseWrap>
                <OpeningStock key="op" vtype={VTYPE.OPENING_STOCK} />
              </SuspenseWrap>
            ),
          },
          {
            path: "damageentry",
            element: (
              <SuspenseWrap>
                <OpeningStock key="dm" vtype={VTYPE.DAMAGE} />
              </SuspenseWrap>
            ),
          },
          {
            path: "prescriptionwithoutorder",
            element: (
              <SuspenseWrap>
                <PrescriptionWithoutOrder />
              </SuspenseWrap>
            ),
          },
          {
            path: "purchaselist",
            element: (
              <SuspenseWrap>
                <PurchaseList />
              </SuspenseWrap>
            ),
          },
          {
            path: "purchaseentry",
            element: (
              <SuspenseWrap>
                <PurchaseEntry />
              </SuspenseWrap>
            ),
          },
          {
            path: "purchaseentryedit",
            element: (
              <SuspenseWrap>
                <EditPurchaseEntry />
              </SuspenseWrap>
            ),
          },
          {
            path: "purchasereturnlist",
            element: (
              <SuspenseWrap>
                <PurchaseReturnList />
              </SuspenseWrap>
            ),
          },
          {
            path: "purchasereturnentry",
            element: (
              <SuspenseWrap>
                <PurchaseReturnEntry />
              </SuspenseWrap>
            ),
          },
          {
            path: "purchasereturnentryedit",
            element: (
              <SuspenseWrap>
                <EditPurchaseReturnEntry />
              </SuspenseWrap>
            ),
          },
          {
            path: "salelist",
            element: (
              <SuspenseWrap>
                <SaleList />
              </SuspenseWrap>
            ),
          },
          {
            path: "saleentry",
            element: (
              <SuspenseWrap>
                <SaleEntry />
              </SuspenseWrap>
            ),
          },
          {
            path: "poslist",
            element: (
              <SuspenseWrap>
                <POSList />
              </SuspenseWrap>
            ),
          },
          {
            path: "posentry",
            element: (
              <SuspenseWrap>
                <POSEntry />
              </SuspenseWrap>
            ),
          },
          {
            path: "posentryedit",
            element: (
              <SuspenseWrap>
                <EditPOSEntry />
              </SuspenseWrap>
            ),
          },
          {
            path: "saleentryedit",
            element: (
              <SuspenseWrap>
                <EditSaleEntry />
              </SuspenseWrap>
            ),
          },
          {
            path: "orderlist",
            element: (<SuspenseWrap><OrderList /></SuspenseWrap>),
          },
          {
            // Same screen as "Order (Home Delivery)" above — only the deliveryType
            // filter sent to the API differs. `key` forces a remount when switching
            // between the two menu items so the tab/page state doesn't carry over.
            path: "orderlistpickup",
            element: (<SuspenseWrap><OrderList key="pickup" deliveryType="PICKUP" /></SuspenseWrap>),
          },
          {
            path: "orderdetail",
            element: (<SuspenseWrap><OrderDetail /></SuspenseWrap>),
          },
          {
            path: "returnrequestlist",
            element: (<SuspenseWrap><ReturnRequestList /></SuspenseWrap>),
          },
          {
            path: "orderdeliveryboyassign",
            element: (<SuspenseWrap><ReturnRequestList /></SuspenseWrap>),
          },
          {
            path: "banner",
            element: (<SuspenseWrap><Banner /></SuspenseWrap>),
          },
          {
            path: "banneradd",
            element: (<SuspenseWrap><AddBanner /></SuspenseWrap>),
          },
          {
            path: "banneredit",
            element: (<SuspenseWrap><EditBanner /></SuspenseWrap>),
          },
          {
            path: "stock/itemwise",
            element: (<SuspenseWrap><StockItemWise /></SuspenseWrap>),
          },
          {
            path: "stock/batchwise",
            element: (<SuspenseWrap><StockBatchWise /></SuspenseWrap>),
          },
          {
            path: "stock/mrpwise",
            element: (<SuspenseWrap><StockMrpWise /></SuspenseWrap>),
          },
          {
            path: "deliveryboy",
            element: (<SuspenseWrap><DeliveryBoy /></SuspenseWrap>),
          },
          {
            path: "deliveryboyadd",
            element: (<SuspenseWrap><AddDeliveryBoy /></SuspenseWrap>),
          },
          {
            path: "deliveryboyedit",
            element: (<SuspenseWrap><EditDeliveryBoy /></SuspenseWrap>),
          },
          {
            path: "users",
            element: (
              <SuspenseWrap>
                <Users />
              </SuspenseWrap>
            ),
          },
          {
            path: "useradd",
            element: (
              <SuspenseWrap>
                <AddUser />
              </SuspenseWrap>
            ),
          },
          {
            path: "useredit",
            element: (
              <SuspenseWrap>
                <EditUser />
              </SuspenseWrap>
            ),
          },
          {
            path: "mr",
            element: (<SuspenseWrap><ComingSoon title="MR" /></SuspenseWrap>),
          },
          {
            path: "assignpincode",
            element: (<SuspenseWrap><ComingSoon title="Assign Pincode" /></SuspenseWrap>),
          },
          {
            path: "issueso",
            element: (<SuspenseWrap><ComingSoon title="Issue SO" /></SuspenseWrap>),
          },
          {
            path: "receivedbo",
            element: (<SuspenseWrap><ComingSoon title="Received BO" /></SuspenseWrap>),
          },
          {
            path: "purchaseorder",
            element: (<SuspenseWrap><ComingSoon title="Purchase Order" /></SuspenseWrap>),
          },
          {
            path: "publishstock",
            element: (<SuspenseWrap><ComingSoon title="Publish Stock" /></SuspenseWrap>),
          },
          {
            path: "customers",
            element: (<SuspenseWrap><ComingSoon title="Customer List" /></SuspenseWrap>),
          },
          {
            path: "managewallet",
            element: (<SuspenseWrap><ComingSoon title="Manage Wallet" /></SuspenseWrap>),
          },
          {
            path: "report/collection",
            element: (<SuspenseWrap><ComingSoon title="Collection Register" /></SuspenseWrap>),
          },
          {
            path: "report/order",
            element: (<SuspenseWrap><ComingSoon title="Order Register" /></SuspenseWrap>),
          },
          {
            path: "report/purchase",
            element: (<SuspenseWrap><ComingSoon title="Purchase Register" /></SuspenseWrap>),
          },
          {
            path: "report/purchasedetails",
            element: (<SuspenseWrap><ComingSoon title="Purchase Register Details" /></SuspenseWrap>),
          },
          {
            path: "report/sale",
            element: (<SuspenseWrap><ComingSoon title="Sale Register" /></SuspenseWrap>),
          },
          {
            path: "report/billo",
            element: (<SuspenseWrap><ComingSoon title="Bill O" /></SuspenseWrap>),
          },
          {
            path: "report/customerledger",
            element: (<SuspenseWrap><ComingSoon title="Customer Ledger" /></SuspenseWrap>),
          },
          {
            path: "report/po",
            element: (<SuspenseWrap><ComingSoon title="PO Register" /></SuspenseWrap>),
          },
          {
            path: "stock/sostocklist",
            element: (<SuspenseWrap><ComingSoon title="SO Stock List" /></SuspenseWrap>),
          },
          {
            path: "userpermission",
            element: (<SuspenseWrap><ComingSoon title="User Permission" /></SuspenseWrap>),
          },
          {
            path: "dashboardpermission",
            element: (<SuspenseWrap><ComingSoon title="Dashboard Permission" /></SuspenseWrap>),
          },
          {
            path: "*",
            element: (<SuspenseWrap><ComingSoon /></SuspenseWrap>),
          },
        ],
      },
    ],
  },
];

export default routes;
